import { useState } from 'react'

import { Tab } from 'components'
import { SuccessModal } from 'components/SuccessModal/SuccessModal'
import { useLoading, useToggle, useModal } from 'hooks'
import {
  IFornecedor,
  SupplierRegistrationServices
} from 'services/NGT/SupplierRegistration'
import { FORMAT } from 'utils'

import {
  SearchSupplierRegistration,
  SupplierRegistrationForm
} from './components'

export default function SupplierRegistration() {
  const tabs = ['Pesquisar', 'Adicionar Novo']

  const { loading, msgErro, setLoading } = useLoading()
  const [isModalOpen, toggleModal] = useToggle()
  const { showModal } = useModal()

  const [selectedTab, setSelectedTab] = useState(0)

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  interface IContatos {
    nmContato?: string
    txEmail?: string
    cdTipo?: string
  }

  const cleanContacts = (contacts: IContatos[]) =>
    contacts
      .filter(
        (contact) => contact.cdTipo && contact.nmContato && contact.txEmail
      )
      .map((contact) => ({
        cdTipo: contact.cdTipo,
        nmContato: contact.nmContato,
        txEmail: contact.txEmail
      }))

  const handleSubmitForm = (data: IFornecedor) => {
    const requestData = {
      ...data,
      cdCep: FORMAT.unMask(data.cdCep),
      cdCpfResponsavel: isNaN(parseInt(data.cdCpfResponsavel))
        ? data.cdCpfResponsavel
        : FORMAT.unMask(data.cdCpfResponsavel),
      cdDocto:
        data.cdTipoFornecedor === 'E'
          ? data.cdDocto
          : FORMAT.unMask(data.cdDocto),
      flSap: false,
      nuTelefone: FORMAT.unMask(data.nuTelefone),
      tFornecedorContatos: [
        ...cleanContacts(data.contatosComercial),
        ...cleanContacts(data.contatosImportacao),
        ...cleanContacts(data.contatosSeguranca),
        ...cleanContacts(data.contatosTrabalhista)
      ]
    }
    delete requestData.contatosComercial
    delete requestData.contatosTrabalhista
    delete requestData.contatosSeguranca
    delete requestData.contatosImportacao

    setLoading('loading')
    SupplierRegistrationServices()
      .create(requestData)
      .then((response) => {
        if (response.status !== 200 || !response.data.sucesso) {
          throw new Error(
            response.data.mensagem ||
            'Erro ao cadastrar Fornecedor, tente novamente!'
          )
        }

        toggleModal()
        setLoading('idle')
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          // CORREÇÃO: Usar a mensagem de erro vinda do back-end
          message: error.message,
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 ? (
        <SearchSupplierRegistration />
      ) : (
        <>
          <SupplierRegistrationForm
            handleSubmitForm={handleSubmitForm}
            isModalOpen={isModalOpen}
            toggleModal={toggleModal}
          />
          <SuccessModal
            open={loading === 'error'}
            message={msgErro}
            type="error"
            hideButtonCancel
            handleConfirm={() => setLoading('idle')}
            txtButtonConfirm="Voltar"
          />
          <SuccessModal
            open={isModalOpen}
            message="Dados incluídos com sucesso!"
            type="sucess"
            hideButtonCancel
            txtButtonConfirm="OK"
            handleConfirm={() => {
              toggleModal()
              setSelectedTab(0)
            }}
          />
        </>
      )}
    </>
  )
}
